<nz-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [nzDisabled]="disabled" [nzMode]="hxMode"
           nzPlaceHolder="Выберите бренд" [nzDropdownMatchSelectWidth]="false" nzAllowClear nzShowSearch>
  <nz-option *ngFor="let op of options" [nzLabel]="op.title" [nzValue]="op.id"></nz-option>
</nz-select>
